import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { StartComponent } from './start/start.component';
import { startRouting } from './start.routes';
import { FormsModule } from '@angular/forms';
import { FormModule } from 'src/app/core/components/form/form.module';
import { PopupModule } from '../../core/components/popup/popup.module';
import { TableModule } from 'src/app/core/components/table/table.module';

@NgModule({
    declarations: [StartComponent],
    providers: [DatePipe, CurrencyPipe],
    imports: [startRouting, CommonModule, PopupModule, FormsModule, FormModule, TableModule],
})
export class StartModule {}
